/**
 * Shared constants for insights visualization components
 * Single source of truth for path modes, node types, and ring distances
 */

/**
 * Path mode options for visualization filtering
 * Used by ThreatVisualizer.vue and CVEVisualizerHeader.vue
 */
export const PATH_MODE_OPTIONS = {
  full: {
    label: 'Full',
    icon: 'mdi-arrow-expand-horizontal',
    path: 'Domain → Asset → Tech → CVE → CWE → CAPEC → TTP → APT',
  },
  attack: {
    label: 'Attack',
    icon: 'mdi-shield-alert',
    path: 'CVE → CWE → CAPEC → TTP → APT',
  },
  threat: {
    label: 'Threat',
    icon: 'mdi-target',
    path: 'CVE → TTP → APT',
  },
  direct: {
    label: 'Direct',
    icon: 'mdi-flash',
    path: 'CVE → APT',
  },
};

/**
 * Node type constants with UPPERCASE prefixes (matching backend)
 */
export const NODE_TYPES = {
  ORG: 'org',
  ASSET: 'asset',
  TECH: 'tech',
  CVE: 'cve',
  CWE: 'cwe',
  CAPEC: 'capec',
  TTP: 'ttp',
  APT: 'apt',
};

/**
 * Node ID prefixes (UPPERCASE to match backend)
 */
export const NODE_PREFIXES = {
  ORG: 'ORG:',
  ASSET: 'ASSET:',
  TECH: 'TECH:',
  CVE: 'CVE-',
  CWE: 'CWE-',
  CAPEC: 'CAPEC-',
  TTP: 'T',
  APT: 'APT:',
};

/**
 * Ring distances for D3 radial graph layout
 * Used by threatVisualizerEngine.js and d3GraphUtils.js
 */
export const RING_DISTANCES = {
  asset: 120,
  tech: 240,
  cve: 380,
  cwe: 520,
  capec: 680,
  ttp: 860,
  apt: 1060,
};

/**
 * Column positions for Sankey/Flow layout
 */
export const COLUMN_POSITIONS = {
  org: 0,
  asset: 1,
  tech: 2,
  cve: 3,
  cwe: 4,
  capec: 5,
  ttp: 6,
  apt: 7,
};
